import React from "react";
import { useTranslation } from "react-i18next";

type SelfieResultProps = {
    selfieResultText: string,
    selfieResultBtns: object,
    selfieImg: string;
    handleRetry: () => void;
    handleSubmitBtn: () => void;
};

const SelfieResult: React.FC<SelfieResultProps> = ({ selfieResultText, selfieResultBtns, selfieImg, handleRetry, handleSubmitBtn }) => {
    const { t } = useTranslation();

    return (
        <div id="selfie-result-block" className="tangent_selfie_result_screen_custom tangent_selfie_result_screen_mob_custom tngnt-flex tngnt-flex-col tngnt-items-center tngnt-gap-4 sm:tngnt-gap-6 tngnt-pt-16 sm:tngnt-p-6 sm:tngnt-pt-16 tngnt-justify-center tngnt-w-[100%]">
            <img className="tangent_selfie_result_image_custom tangent_selfie_result_image_mob_custom tngnt-max-w-[400px] tngnt-max-h-[300px] sm:tngnt-max-w-[500px] sm:tngnt-max-h-[400px]" src={selfieImg} alt='user selfie' />
            <div className="tangent_global_style tangent_global_style_custom tangent_selfie_result_text_custom tangent_selfie_result_text_mob_custom tngnt-text-center tngnt-text-[20px]" dangerouslySetInnerHTML={{ __html: selfieResultText }} />
            <div className='tngnt-flex tngnt-justify-center tngnt-items-center tngnt-gap-6 tngnt-w-[100%] tngnt-align-middle tngnt-flex-wrap tngnt-flex-row'>
                <button className="tangent_global_style tangent_global_style_custom tangent_secondary_button tangent_secondary_button_custom tangent_selfie_retry_button_custom tangent_selfie_retry_button_mob_custom tngnt-border tngnt-p-2 tngnt-text-[#eb6969] tngnt-bg-white tngnt-border-[#eb6969]
                    tngnt-rounded-[5px] tngnt-shadow-md tngnt-w-[40%]"
                    onClick={handleRetry} dangerouslySetInnerHTML={{ __html: selfieResultBtns?.selfieRetry ?? t('selfieRetry') }} />
                <button className="tangent_global_style tangent_global_style_custom tangent_primary_button tangent_primary_button_custom tangent_selfie_next_button_custom primary_button tangent_selfie_next_button_mob_custom tngnt-border tngnt-p-2 tngnt-bg-[#eb6969] tngnt-text-white
                    tngnt-rounded-[5px] tngnt-shadow-md tngnt-w-[40%]"
                    onClick={handleSubmitBtn} dangerouslySetInnerHTML={{ __html: selfieResultBtns?.selfieNext ?? t('selfieNext') }} />
            </div>
        </div>
    )
}

export default SelfieResult